import { render } from "./GamesActivitySection.vue?vue&type=template&id=de9a944e&scoped=true"
import script from "./GamesActivitySection.vue?vue&type=script&lang=js"
export * from "./GamesActivitySection.vue?vue&type=script&lang=js"

import "./GamesActivitySection.vue?vue&type=style&index=0&id=de9a944e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de9a944e"]])

export default __exports__